export const maskEmail = (email?: string | null | undefined): string => {
	if (typeof email === 'string' && email.match(/@/)) {
		const [emailName, emailDomain] = email.split('@');
		const hiddenName = `${emailName.charAt(0)}*****${emailName.charAt(
			emailName.length - 1
		)}`;

		return `${hiddenName}@${emailDomain}`;
	}

	return '';
};

export { logBuildInfo } from './logBuildInfo';
export { loadScript, removeScript } from './scriptLoader';
export { initSentry } from './sentry';
